// filepath: src/components/user-info-header/styles.ts
import styled from "styled-components";
 
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #f8f9fa;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  min-width: 280px;
`;

export const InfoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PrimaryText = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #202124;
`;

export const SecondaryText = styled.span`
  font-size: 13px;
  color: #5f6368;
`;

export const LogoutButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5f6368;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: #f1f3f4;
    color: #ea4335;
  }
`;